import { render } from "./App.vue?vue&type=template&id=6ffac25e&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=6ffac25e&lang=scss&scoped=true"

import exportComponent from "/root/.edison/edisoncd/scenarios/edison-cd-task-deploy-lite-branch/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffac25e"]])

export default __exports__